// One cell of a CSV file. A text cell that starts with = + - @ (or a tab or return) is run as a formula when the
// file is opened in a spreadsheet, so a name like =HYPERLINK(...) would execute on the person who opens the export.
// Such cells get a leading apostrophe, which the spreadsheet shows as plain text. Plain numbers (-500, +12.5) are
// not formulas and stay as they are (triage FE-06-08).
export function csvValue(value) {
  let text = String(value ?? "");
  if (/^[=+\-@\t\r]/.test(text) && !/^[+-]?\d+(\.\d+)?$/.test(text)) text = `'${text}`;
  return /[",\n\r]/.test(text) ? `"${text.split('"').join('""')}"` : text;
}
